import { useCallback, useState } from "react";
import { toast } from "@/components/ui/use-toast";
import logger from "@/lib/logger";
import { formatMessage } from "@/lib/utils";

export function useCopyToClipboard() {
  const [text, setText] = useState<string | null>(null);

  const copy = useCallback(
    async (
      text: string,
      { timeout, withToast }: { timeout?: number; withToast?: boolean } = {
        timeout: 3000,
        withToast: false
      }
    ) => {
      if (!navigator?.clipboard) {
        logger.warn("Clipboard not supported");
        return false;
      }

      try {
        await navigator.clipboard.writeText(text);
        setText(text);

        if (timeout) {
          setTimeout(() => {
            setText(null);
          }, timeout);
        }

        if (withToast) {
          toast({
            title: "Copied to clipboard",
            description: text,
            variant: "default"
          });
        }

        return true;
      } catch (error) {
        logger.warn("Copy failed", formatMessage(error));
        setText(null);
        return false;
      }
    },
    []
  );

  return { text, copy, isCopied: text !== null };
}
